import request from '..';

const SERVER = `${process.env.REACT_APP_SERVER_ENVIRONMENT}/api/v1/pss-bff-public`;

export const createThirdPartyClaim = async (data: any) => {
  return await request({
    url: `${SERVER}/third-party-claims`,
    method: 'POST',
    data,
    headers: { 'Content-Type': 'application/json' },
  });
};

// Resumen público del reclamo por id (UUID). Se consume desde la vista de resumen
// a la que apunta el link del correo de confirmación.
export const getThirdPartyClaimById = async (id: string) => {
  return await request({
    url: `${SERVER}/third-party-claims/${id}`,
    method: 'GET',
  });
};

// Documento adjunto del reclamo en base64 ({ buffer, contentType }), para que el
// cliente lo previsualice/descargue desde el resumen público. Se usa base64 (no URL
// firmada) para garantizar la previsualización inline sin depender del Content-Type
// del objeto en S3.
export const getThirdPartyClaimDocumentBase64 = async (id: string, documentId: string) => {
  return await request({
    url: `${SERVER}/third-party-claims/${id}/documents/${documentId}/view`,
    method: 'GET',
  });
};
